import PropTypes from "prop-types";
import { useState } from "react";
import { Link } from "react-router-dom";
import { resolveImage } from "../cart-redesign/pricing";
import { initials } from "./profileData";

/*
 * Saved items come from the wishlist already held in the store, so the
 * strip needs no request of its own. A catalogue image that no longer
 * resolves falls back to an initials tile.
 */
const Card = ({ item, formatPrice }) => {
  const [broken, setBroken] = useState(false);
  const src = item.mainImage ? resolveImage(item.mainImage) : "";
  const price = item.price?.basePrice;

  return (
    <li className="c4prf__wish">
      <Link to={process.env.PUBLIC_URL + `/product/${item._id}`}>
        <span className="c4prf__wish-img">
          {src && !broken ? (
            <img src={src} alt="" onError={() => setBroken(true)} />
          ) : (
            <span className="c4prf__wish-fallback" aria-hidden="true">
              {initials(item.name)}
            </span>
          )}
        </span>
        <span className="c4prf__wish-name">{item.name}</span>
        {price != null ? (
          <span className="c4prf__wish-price">{formatPrice(price)}</span>
        ) : null}
      </Link>
    </li>
  );
};

Card.propTypes = { item: PropTypes.object, formatPrice: PropTypes.func };

const WishlistStrip = ({ items, formatPrice }) => (
  <ul className="c4prf__wishes">
    {items.map((item) => (
      <Card item={item} formatPrice={formatPrice} key={item._id} />
    ))}
  </ul>
);

WishlistStrip.propTypes = {
  items: PropTypes.array.isRequired,
  formatPrice: PropTypes.func.isRequired,
};

export default WishlistStrip;
